import moment from "moment";
import React, {useMemo} from "react";
import {PracticeId} from "src/constants/practiceIds";

import {guess} from "../../../../_services/api";
import {MonolithLocationFields} from "../../../../_services/graphql/queries/location";
import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import {BookingPracticeAppointmentReasonFieldsFragment} from "../../../../page-containers/booking/graphql/__generated__/FetchAppointmentReasons.type";
import {s3ImageSource} from "../../../../useS3ImgSrc";
import {formatPhoneNumber} from "../../../_common/Carbon";
import NextImage from "../../NextImage";
import {useSpecialtyByIdQuery} from "./graphql/__generated__/specialty-by-id.type";

type ConfirmationTileProps = {
  location?: MonolithLocationFields;
  practiceAppointmentReason?: BookingPracticeAppointmentReasonFieldsFragment;
  selectedTime?: number;
  specialtyId: string;
};
const ConfirmationTile = ({
  location,
  practiceAppointmentReason,
  selectedTime,
  specialtyId,
}: ConfirmationTileProps) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const i18nDB = useTranslation(I18nNamespace.DB);
  const timezone = location?.timezone ?? guess();
  const momentTime = moment(selectedTime).tz(timezone);
  const todayTomorrow = useMemo(
    () =>
      momentTime.calendar(null, {
        sameDay: `[${i18n.t("Today", {ns: "web-scheduling"})}]`,
        nextDay: `[${i18n.t("Tomorrow", {ns: "web-scheduling"})}]`,
        nextWeek: "[]",
        lastDay: "[]",
        lastWeek: "[]",
        sameElse: "[]",
      }),
    [i18n, momentTime],
  );
  const {data} = useSpecialtyByIdQuery({
    variables: {practiceId: location?.practiceId ?? PracticeId.CARBON, specialtyId},
  });

  return (
    <div className="mt-12 shadow-md rounded-3xl overflow-hidden">
      <div className="flex">
        <div className="flex-1 bg-lightMint py-6 px-4 font-i">
          {todayTomorrow && <div className="">{todayTomorrow}</div>}
          <div className="mt-1">{momentTime.format("hh:mma z")}</div>
          <div className="mt-2 text-[2rem] leading-10">{momentTime.format("MMM D")}</div>
        </div>
        <div className="flex-1 relative">
          <NextImage
            src={s3ImageSource("a41764e5-787d-42b5-b1a2-cb31fd43b8ca")}
            layout="fill"
            objectFit="cover"
            alt=""
          />
        </div>
      </div>
      <div className="flex p-4 flex-col sm:flex-row">
        <div className="flex-1">
          <div className="font-i font-semibold">
            {i18nDB.t(practiceAppointmentReason?.appointmentReason?.name || "", {
              ns: "website-db",
            })}
            {" · "}
            {i18n.t("{{specialtyName}} Visit", {
              specialtyName: data?.practice?.specialty?.name || "",
              ns: "web-scheduling",
            })}
          </div>
          <div className="font-i mt-4 sm:mt-2 empty:hidden">{location?.address.firstLine}</div>
          <a
            href={`tel:${location?.phoneNumber}`}
            className="font-i mt-4 sm:mt-2 empty:hidden text-gray-1000 hover:text-gray-800 underline underline-offset-2"
          >
            {formatPhoneNumber(location?.phoneNumber || "")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConfirmationTile);
